import React, { useState, useEffect } from "react";
import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_FOLDER}get_artforms/`;
const API_TOKEN = process.env.REACT_APP_API_TOKEN;

function ArtformCheck({ value, onChange }) {
  const [options,   setOptions]   = useState([]);
  const [error,     setError]     = useState(null);

  /* fetch list once */
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(API_URL, { headers: { "X-API-TOKEN": API_TOKEN } });
        setOptions(data);
      } catch (err) {
        setError(err.message || "Failed to fetch artforms");
      }
    })();
  }, []);

  /* toggle helper */
  const toggle = (art) => {
    const next = new Set(value);
    next.has(art) ? next.delete(art) : next.add(art);
    onChange(next);
  };

  return (
    <aside className="package-widget widget-tour-categoris mt-30">
      <div className="widget-title"><h4>Artform / subject</h4></div>
      <div className="widget-body">
        {error && <p className="text-danger">{error}</p>}
        <ul className="list-unstyled m-0">
          {options.map((art) => (
            <li key={art} className="category-check d-flex align-items-center mb-1">
              <input
                id={`af-${art}`}
                className="form-check-input me-2"
                type="checkbox"
                checked={value.has(art.toLowerCase())}
                onChange={() => toggle(art.toLowerCase())}
              />
              <label htmlFor={`af-${art}`} className="form-check-label artform-check-label">
                <i className="bi bi-chevron-double-right" /> {art}
              </label>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}
export default ArtformCheck;
